import { gql } from "@apollo/client";

export const GET_ALERT_ANALYSIS = gql`
  query GetAlertAnalysis($vmId: Int!) {
    getAlertAnalysis(vmId: $vmId) {
      id
      vmId
      vmName
      alertHasPattern
      alertPatternDescription
      frequencyPerDay
      averageDurationMinutes
      peakHour
      peakDay
      predictionNextAlert
      predictionTrend
      anomalyDetected
      anomalyDetails
      suggestionAction
      suggestionText
      createdAt
    }
  }
`;

export const ANALYZE_ALERTS_FOR_VM = gql`
  mutation AnalyzeAlertsForVm($vmId: Int!) {
    analyzeAlertsForVm(vmId: $vmId)
  }
`;

export const ANALYZE_ALL_VMS_ALERTS = gql`
  mutation AnalyzeAllVmsAlerts {
    analyzeAllVmsAlerts
  }
`;